import { Box } from "@mui/material";
import { MicIcon } from "../Icons/MicIcon";
import { customWhite } from "../../theme/palette";
import { StyledMicIcon } from "../AudioPlayer/AudioPlayer.styled";

interface InitialMicrophoneButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export function InitialMicCheckState({
  onClick,
  disabled = false,
}: InitialMicrophoneButtonProps) {
  return (
    <Box
      marginLeft={4}
      marginRight={4}
      sx={{
        margin: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: 90,
        height: 90,
      }}
    >
      <StyledMicIcon
        variant="contained"
        color="primary"
        disableRipple
        sx={{
          width: 70,
          height: 70,
          ...(disabled && {
            opacity: 0.6,
            cursor: "not-allowed",
            pointerEvents: "none",
          }),
        }}
        aria-label="Start Microphone Check"
        onClick={disabled ? undefined : onClick}
        disabled={disabled}
      >
        <MicIcon pathFill={customWhite.main} />
      </StyledMicIcon>
    </Box>
  );
}
